import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"

import { SnackbarOrigin, SnackbarProvider } from "notistack"
import { ReactNode } from "react"
import { Provider } from "react-redux"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import ThemeProvider from "../components/Layout/ThemeProvider"
import { NotificationsProvider } from "../components/Toasts/NotificationsProvider.ctx"
import ModalProvider from "../context/modal"
import { RequestQueueProvider } from "../context/notifications/requestQueue.ctx"
import BUThemeProvider from "../context/theme/theme.ctx"
import { UserMetricsProvider } from "../context/user/metrics.ctx"
import { UserProvider } from "../context/user/user.ctx"
import { store } from "../redux/store"
import { PerformanceContextProvider } from "../sections/Performance/Performance.ctx"
const snackbarProps: { anchorOrigin: SnackbarOrigin } = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "center",
  },
}

const Providers = ({ children }: { children: ReactNode }) => {
  return (
    <Provider store={store}>
      <ThemeProvider>
        <BUThemeProvider>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <SnackbarProvider {...snackbarProps}>
              <RequestQueueProvider>
                <NotificationsProvider>
                  <UserMetricsProvider>
                    <UserProvider>
                      <PerformanceContextProvider>
                        <ModalProvider>{children}</ModalProvider>
                      </PerformanceContextProvider>
                    </UserProvider>
                  </UserMetricsProvider>
                </NotificationsProvider>
              </RequestQueueProvider>
            </SnackbarProvider>
          </LocalizationProvider>
          <ToastContainer position="bottom-right" newestOnTop />
        </BUThemeProvider>
      </ThemeProvider>
    </Provider>
  )
}

export default Providers
